export default __webpack_public_path__ + "static/media/iLicense.e9844b0d.jpg";